import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import { IGuaranteesList } from '../ContentWrapper';
import GuaranteesList from '../GuaranteesList';

interface GuaranteesListProps {
  guarantees: IGuaranteesList;
}

const CompleteGuaranteesList: FC<GuaranteesListProps> = (props) => {
  const { guarantees } = props;

  return (
    <Flex direction="column" gap="space-32">
      <GuaranteesList guarantees={guarantees.include} isInclude={true} />
      <GuaranteesList guarantees={guarantees.exclude} isInclude={false} />
    </Flex>
  );
};

export default CompleteGuaranteesList;
